import api from "@modules/api/api";
import { useMutation } from "@tanstack/react-query";

type Request = {
  email: string;
  source: string;
  tradeInToken: string;
};

const postValidateEmailForTradeInMutation = async ({
  email,
  source,
  tradeInToken,
}: Request): Promise<{ isValid: boolean }> => {
  return api.post(`api/trade-in/${source}/validate-email-for-trade-in`, {
    json: {
      email,
    },
    headers: {
      authorization: `Bearer ${tradeInToken}`,
    },
  });
};

export default function useValidateEmailForTradeInMutation() {
  return useMutation({
    mutationFn: postValidateEmailForTradeInMutation,
  });
}
